import script from "./NewSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewSummary.vue?vue&type=script&setup=true&lang=ts"

import "./NewSummary.vue?vue&type=style&index=0&id=0da016ae&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da016ae"]])

export default __exports__